





























































































































import Vue from "vue";
import DatumsbereichAuswahl from "@/components/util/DatumsbereichAuswahl.vue";
import ExportDialog from "./ConvenienceVerkaufExportDialog.vue";
import {
   Lieferant,
   Warengruppe,
   Filiale,
   ConvenienceVerkaufFilter,
   VerkaufStatistikZeile,
   BatchRequest,
   BatchResponse,
   GTINListResponse,
} from "@/models/ConvenienceVerkaufModel";
import { api } from "@/util/api";

export default Vue.extend({
   name: "ConvenienceVerkauf",
   components: {
      DatumsbereichAuswahl,
      ExportDialog,
   },
   data() {
      return {
         filterData: {
            von: new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)
               .toISOString()
               .split("T")[0],
            bis: new Date().toISOString().split("T")[0],
            filialen: undefined,
            lieferanten: undefined,
            warengruppen: undefined,
            nur_verkaufte: false,
         } as ConvenienceVerkaufFilter,
         tableData: [] as VerkaufStatistikZeile[],
         lieferanten: [] as Lieferant[],
         warengruppen: [] as Warengruppe[],
         filialen: [] as Filiale[],
         isLoading: false,
         showExportDialog: false,
         batchSize: 50,
         allGTINs: [] as string[],
         currentBatchIndex: 0,
      };
   },
   computed: {
      headers() {
         const baseHeaders = [
            { text: "GTIN", value: "GTIN", width: 120 },
            { text: "Artikel", value: "Artikel", width: 250 },
            { text: "Lieferant", value: "Lieferant", width: 150 },
            {
               text: "Lief-Preis",
               value: "MandantPreis",
               align: "right",
               width: 110,
            },
            {
               text: "Kasse-Preis",
               value: "KassePreis",
               align: "right",
               width: 110,
            },
            { text: "EKP", value: "TabaconEKP", align: "right", width: 90 },
            {
               text: "Steuersatz",
               value: "Steuersatz",
               align: "right",
               width: 95,
            },
            {
               text: "Spanne",
               value: "Handelsspanne",
               align: "right",
               width: 90,
            },
            { text: "Warengruppe", value: "Warengruppe", width: 150 },
            {
               text: "Gesamt Stück",
               value: "GesamtStueck",
               align: "right",
               width: 110,
            },
         ];
         return baseHeaders;
      },
   },
   beforeMount() {
      this.loadFilters();
   },
   methods: {
      onDateRangeChange(value: { von: string; bis: string }) {
         this.filterData.von = value.von;
         this.filterData.bis = value.bis;
      },
      async loadFilters() {
         try {
            const [lieferantenRes, warengruppenRes] = await Promise.all([
               api.get<Lieferant[]>("v1/convenience/lieferanten"),
               api.get<Warengruppe[]>("v1/convenience/warengruppen"),
            ]);

            if (
               !api.isErrorResponse(lieferantenRes.data) &&
               Array.isArray(lieferantenRes.data)
            ) {
               this.lieferanten = lieferantenRes.data;
            }
            if (
               !api.isErrorResponse(warengruppenRes.data) &&
               Array.isArray(warengruppenRes.data)
            ) {
               this.warengruppen = warengruppenRes.data;
            }

            // TODO: Load filialen from backend if available
            // For now, using placeholder
            this.filialen = [];
         } catch (error) {
            console.error("Failed to load filters:", error);
            this.$root.$emit("show-error", "Fehler beim Laden der Filter");
         }
      },
      async loadData() {
         if (this.isLoading) return;

         this.isLoading = true;
         this.tableData = [];
         this.allGTINs = [];
         this.currentBatchIndex = 0;

         try {
            // Phase A: Get all GTINs
            const gtinResponse = await api.get<GTINListResponse>(
               "v1/statistiken/verkauf/gtin/liste",
               {
                  params: this.buildQueryParams(),
               }
            );

            if (!api.isErrorResponse(gtinResponse.data)) {
               this.allGTINs = gtinResponse.data.GTINs || [];
            }

            if (this.allGTINs.length === 0) {
               this.isLoading = false;
               return;
            }

            // Phase B+C: Load in batches
            await this.loadNextBatch();
         } catch (error) {
            console.error("Failed to load data:", error);
            this.$root.$emit("show-error", "Fehler beim Laden der Daten");
            this.isLoading = false;
         }
      },
      async loadNextBatch() {
         if (this.currentBatchIndex >= this.allGTINs.length) {
            this.isLoading = false;
            return;
         }

         try {
            const endIndex = Math.min(
               this.currentBatchIndex + this.batchSize,
               this.allGTINs.length
            );
            const batchGTINs = this.allGTINs.slice(
               this.currentBatchIndex,
               endIndex
            );

            const batchRequest: BatchRequest = {
               GTINs: batchGTINs,
               Von: this.filterData.von,
               Bis: this.filterData.bis,
               Filiale: this.filterData.filialen,
               Lieferant:
                  this.filterData.lieferanten &&
                  this.filterData.lieferanten.length === 1
                     ? this.filterData.lieferanten[0]
                     : undefined,
               Warengruppen: this.filterData.warengruppen,
               NurVerkaufte: this.filterData.nur_verkaufte,
            };

            const response = await api.post<BatchResponse>(
               "v1/statistiken/verkauf/gtin/batch",
               batchRequest as unknown as Record<string, unknown>
            );

            if (!api.isErrorResponse(response.data)) {
               this.tableData.push(...(response.data.Data || []));
            }
            this.currentBatchIndex = endIndex;

            // Load next batch with a small delay
            if (this.currentBatchIndex < this.allGTINs.length) {
               setTimeout(() => this.loadNextBatch(), 100);
            } else {
               this.isLoading = false;
            }
         } catch (error) {
            console.error("Failed to load batch:", error);
            this.$root.$emit("show-error", "Fehler beim Laden eines Batches");
            this.isLoading = false;
         }
      },
      onFilterChange() {
         // Reset data when filter changes
         this.tableData = [];
         this.allGTINs = [];
         this.currentBatchIndex = 0;
      },
      onExportComplete() {
         this.showExportDialog = false;
         this.$root.$emit("show-success", "Export erfolgreich heruntergeladen");
      },
      buildQueryParams() {
         // eslint-disable-next-line @typescript-eslint/no-explicit-any
         const params: any = {};
         if (this.filterData.von) params.von = this.filterData.von;
         if (this.filterData.bis) params.bis = this.filterData.bis;
         if (this.filterData.filialen?.length)
            params.filiale = this.filterData.filialen.join(",");
         if (this.filterData.lieferanten?.length)
            params.lieferant = this.filterData.lieferanten.join(",");
         if (this.filterData.warengruppen?.length)
            params.warengruppen = this.filterData.warengruppen.join(",");
         if (this.filterData.nur_verkaufte) params.nur_verkaufte = "1";
         return params;
      },
      formatCurrency(value: number): string {
         return new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
         }).format(value);
      },
   },
});
